import React from "react";
import PropTypes from "prop-types";
import classes from "classnames";
import { ReactComponent as LogoImg } from "../../images/header-logo.svg";

const LogoHeader = ({ isMobilePopUp }) => {
  const headerClasses = classes(
    "header__logo-wrap",
    isMobilePopUp && "header__logo-wrap--popup"
  );
  return (
    <div className={headerClasses}>
      {LogoImg ? (
        <a href="/" title="L3Harris logo" rel="home" className="logo">
          <LogoImg />
        </a>
      ) : (
        <div className="logo-wrap__preload" />
      )}
    </div>
  );
};

LogoHeader.defaultProps = {
  isMobilePopUp: false,
};

LogoHeader.propTypes = {
  isMobilePopUp: PropTypes.bool,
};

export default LogoHeader;
